export const DATE = 'Date';
//# sourceMappingURL=DATE.js.map